import React from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';

import { BundleWork } from './types';
import { WorkCard } from './WorkCard';

/**
 * V10 (`blurred_hidden_thumbs_v10`) replacement for `FadeFooter`.
 * Renders 1-2 actual hidden papers as blurred WorkCards beneath the
 * visible 6, with a `+N more in pack` caption sitting on top of them.
 * Concretizes the gate (vs the gradient + count treatment) — predicted
 * meaningful CTR lift.
 */
export function BlurredHiddenThumbs({
  works,
  hiddenPapersCount,
}: {
  works: ReadonlyArray<BundleWork>;
  hiddenPapersCount: number;
}) {
  if (works.length === 0 || hiddenPapersCount <= 0) return null;
  return (
    <Container>
      <Caption>
        <Body size="xs" bold>
          +{hiddenPapersCount} more in pack
        </Body>
      </Caption>
      <BlurWrap aria-hidden>
        {works.map((work) => (
          <WorkCard key={work.id} work={work} showRelevancy={false} compact />
        ))}
      </BlurWrap>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const Caption = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  padding: var(--spacing-xs-8, 8px);
  background: rgba(244, 247, 252, 0.85);
  pointer-events: none;
`;

const BlurWrap = styled.div`
  filter: blur(4px);
  opacity: 0.55;
  pointer-events: none;
  user-select: none;
  display: flex;
  flex-direction: column;
`;
